import { render, staticRenderFns } from "./PublishedSellingTendersList.vue?vue&type=template&id=73b8b35e&"
import script from "./PublishedSellingTendersList.vue?vue&type=script&lang=ts&"
export * from "./PublishedSellingTendersList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports